import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { CategoryCard } from './style'
import { EventPointsWrapper } from '../../MainEvents/styles'
import LazyImage from '../../common/LazyImage/LazyImage'
import { ImageUrl } from '../../../utils/constants'
import { t } from 'i18next'
import { 
  GivingBackIconNew,
  DeiIconNew,
  EngagementAndCultureIcon,
  PhysicalMentalWellbeingIconNew,
  NationalDays,
  BenefitsIconNews,
  LearningAndGrowthIconNew 
} from '../../../utils/icons'

const categoryIconMap = {
  "Cultural Festivals": PhysicalMentalWellbeingIconNew,
  "Community Celebrations": EngagementAndCultureIcon,
  "Global Awareness": LearningAndGrowthIconNew,
  "Professional Appreciation Days": DeiIconNew,
  "Health & Wellness Days": BenefitsIconNews,
  "National Days": NationalDays,
  "Fun & Lifestyle Days": GivingBackIconNew,
};

const categoryColorMap = {
  "Cultural Festivals": "#FCF2F3",
  "Community Celebrations":"#F1F8F2",
  "Global Awareness": "#FCF7F0",
  "Professional Appreciation Days": "#F5F6E8",
  "Health & Wellness Days": "#FCF7F0",
  "National Days":"#F1F8F2",
  "Fun & Lifestyle Days":"#FAF5F8",
};

const categoryBorderColorMap = {
  "Cultural Festivals": "#E5B9BD",
  "Community Celebrations": "#A4D6A8",
  "Global Awareness": "#F1D8B4",
  "Professional Appreciation Days": "#D6D9A4",
  "Health & Wellness Days": "#F1D8B4",
  "National Days": "#A4D6A8",
  "Fun & Lifestyle Days": "#E3B8CE",
};

const CompanyOragnizedCategory = ({ history, onSiteCategories }) => (
  <EventPointsWrapper margin gap="12px 8px">

    {onSiteCategories?.length > 0 &&
      onSiteCategories.map((category, index) => {
        if (category?.video_count <= 0) return null;

        const trimmedName = category?.category_name?.trim();

        const IconComponent = categoryIconMap[trimmedName];
        const bgColor = categoryColorMap[trimmedName] || "#f2f2f2";
        const borderColor = categoryBorderColorMap[trimmedName] || "#DCDCDC";

        return (
          <CategoryCard
            key={index}
            style={{ 
              width: "407px",
              border: `0.75px solid #dcdcdc`
            }}
            isBorderRadius={"12px"}
            cardPadding={"12px"}
            cardHeight="72px"
            background={bgColor}
            onClick={() => {
              history.push({
                pathname: `/company/events/library/company-organized/${category.id}`,
                state: { category: category?.category_name },
              });
            }}
          >
            {IconComponent ? (
              <div className="icon"  style={{ border: `1px solid ${borderColor}`,}}>
                <IconComponent />
              </div>
            ) : (
              <LazyImage div={"icon"} src={`${ImageUrl}/${category?.icon}`} />
            )}

            <div className="name" title={t(category.category_name)}>
              {t(category.category_name)}
            </div>
          </CategoryCard>
        );
      })
    }

  </EventPointsWrapper>
);

CompanyOragnizedCategory.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.number,
  ondemandCategory: PropTypes.array,
  fetchOndemandCategory: PropTypes.func,
  onSiteCategories: PropTypes.array.isRequired,
};

export default withTranslation()(CompanyOragnizedCategory);
